import { FactoryProvider } from '@angular/core';
import { InMemoryCache } from '@apollo/client/cache';
import { createHttpLink } from '@apollo/client/link/http';
import { APOLLO_OPTIONS, ApolloModule } from 'apollo-angular';
import { environment } from 'environments';
import possibleTypes from './codegen/possible-types.json';

function createApollo() {
  const cache = new InMemoryCache({
    dataIdFromObject: object => (object as any).id,
    possibleTypes,
  });

  const httpLink = createHttpLink({ uri: environment.THEWALL_URL });

  return {
    link: httpLink,
    cache,
  };
}

export const ApolloProvider: FactoryProvider = {
  provide: APOLLO_OPTIONS,
  useFactory: createApollo,
};

export { ApolloModule };
